module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.13/_next/static/images/hero-mobile-7b94de8ec7cff59b4133ad07df5196d1.png";